require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// ./~/rc-align/~/core-js/library/modules/es7.symbol.observable.js
// module id = 1115
// module chunks = 1